import { templateColumns } from '../../utils/csvTemplate';
import { TAXONOMY_TEMPLATE } from '../../constants/csvTemplates';

// Columns the server reads: `merchantTaxonomyService.parseRegistryCsv` (`src/services/merchantTaxonomyService.ts`).
// The header row must hold the first five (matched loosely: case and spacing do not matter); a row needs a Department
// and its Code, and a Subcategory needs a Category. Product Type and Shopify Category are optional.
const DESCRIPTIONS: Record<string, { required?: boolean; description: string }> = {
  Department: { required: true, description: 'Top-level department, e.g. Cameras.' },
  Code: { required: true, description: 'Department code that prefixes your store SKU, e.g. CAM in CAM-111-00001.' },
  Category: { description: 'Category name, written as you want the Shopify Product Type or Shopify Product Category matched.' },
  Subcategory: { description: 'Subcategory name, written as you want the Shopify Product Type or Shopify Product Category matched.' },
  'Subcategory Code': {
    description: 'The subcategory\'s own code, without the department code: Motzu puts the Code in front, so CAM and 111 give the SKU prefix CAM-111.',
  },
  'Product Type': { description: 'Optional. The Shopify Product Type to send for this subcategory.' },
  'Shopify Category': {
    description: 'Optional. The Shopify Product Category, from Shopify\'s Standard Product Taxonomy: its ID (co-2-2-7), its full GID, or Shopify\'s full path (Cameras & Optics > Cameras > Video Cameras > Camcorders).',
  },
};

/** Props for `CsvTemplateHint` on the Store Taxonomy upload, shared by the v2 step and the legacy card. */
export const taxonomyTemplateProps = {
  fileName: TAXONOMY_TEMPLATE.fileName,
  columns: templateColumns(TAXONOMY_TEMPLATE.headers, TAXONOMY_TEMPLATE.rows, DESCRIPTIONS),
  exampleRows: TAXONOMY_TEMPLATE.rows.map((row) => [...row]),
};
